module.exports = __webpack_public_path__ + "media/images/illustrations/calendar-0aa99e1afb46411f3b1fc7812e167cbb.svg";